import React from 'react';
import { useNavigate } from 'react-router-dom';

interface HeroSectionProps {
    highlightColor: {
        primary: string;
        hover: string;
        gradient: {
            from: string;
            to: string;
            fromLight: string;
            toGray: string;
        };
    };
}

const HeroSection: React.FC<HeroSectionProps> = ({ highlightColor }) => {
    const navigate = useNavigate();

    return (
        <section className="px-4 sm:px-6 lg:px-8 relative overflow-hidden bg-black notebook-grid">
            <div className="max-w-7xl mx-auto relative z-10 w-full pt-20 pb-24 md:pt-24 md:pb-32">
                {/* Headline + CTA */}
                <div className="text-center max-w-3xl mx-auto">
                    <h1 className="text-3xl md:text-5xl font-medium tracking-tight observe-fade opacity-0">
                        <span className="text-white">Connect. Analyze. </span>
                        <span className="text-blue-500">Compete.</span>
                    </h1>
                    <p className="mt-3 text-base md:text-lg text-gray-400 max-w-2xl mx-auto observe-fade opacity-0">
                        Centralize training, recovery, and readiness data in one platform built for your system — delivering predictive insights to help coaches anticipate performance and keep athletes ready.
                    </p>
                    <div className="mt-5 flex items-center justify-center gap-4 observe-fade opacity-0">
                        <button
                            onClick={() => navigate('/contact')}
                            className="inline-flex items-center space-x-2 px-6 py-3 text-sm font-semibold transition-all duration-200 ease-out hover:scale-105 cursor-pointer"
                            style={{
                                backgroundColor: 'transparent',
                                color: 'white',
                                border: '1px solid white',
                                borderRadius: '0',
                                boxShadow: 'none'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = 'white';
                                e.currentTarget.style.color = 'black';
                                e.currentTarget.style.boxShadow = '0 2px 10px -1px rgba(0, 0, 0, 0.1), 0 2px 8px -1px rgba(0, 0, 0, 0.06)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                                e.currentTarget.style.color = 'white';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <span>Get Started</span>
                        </button>
                        <button
                            onClick={() => navigate('/services')}
                            className="inline-flex items-center space-x-2 px-6 py-3 text-sm font-semibold transition-all duration-200 ease-out hover:scale-105 cursor-pointer"
                            style={{
                                backgroundColor: 'transparent',
                                color: 'white',
                                border: '1px solid white',
                                borderRadius: '0',
                                boxShadow: 'none'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = 'white';
                                e.currentTarget.style.color = 'black';
                                e.currentTarget.style.boxShadow = '0 2px 10px -1px rgba(0, 0, 0, 0.1), 0 2px 8px -1px rgba(0, 0, 0, 0.06)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                                e.currentTarget.style.color = 'white';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <span>Learn More</span>
                        </button>
                    </div>
                </div>

                {/* Full-width video below */}
                <div className="mt-8 observe-fade opacity-0">
                    <div className="w-full grid-accent">
                        <div className="overflow-hidden">
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                className="w-full h-auto"
                                src="/videos/dashboard-walkthrough.mp4"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
